import { Directive, Input, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { FeatureFlag } from '../domain/models/feature-flags.enum';
import { FeatureFlagService } from '../util-feature-flag-service/feature-flag.abstract.service';

@Directive({
  selector: '[rmaIfFeatureFlag]',
  standalone: true,
})
export class IfFeatureFlagDirective implements OnInit {
  @Input()
  public rmaIfFeatureFlag: FeatureFlag | undefined;

  constructor(
    private readonly vcRef: ViewContainerRef,
    private readonly tplRef: TemplateRef<unknown>,
    private readonly featureFlagService: FeatureFlagService,
  ) {}

  public ngOnInit(): void {
    if (this.rmaIfFeatureFlag && this.featureFlagService.getFeature(this.rmaIfFeatureFlag, false)) {
      this.vcRef.createEmbeddedView(this.tplRef);
    }
  }
}
